import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppCard, AppRemixIcon } from '@/layout/AppComponents';
import { UnmountClosed } from 'react-collapse';
import styled from 'styled-components';
import { getState } from '../tools/riskManagerTools';
import InecoRiskExpandedContainer from './InecoRiskExpandedContainer';
import _ from 'lodash';

export default function InecoRiskDefault({ elementID }) {
  const resLevel1 = useSelector((state) => state.currentPage?.elementLevels?.level1);
  const [isOpened, setIsOpened] = useState(false);

  const getStateNumber = useCallback(() => {
    const stateNumber =
      resLevel1[elementID]?.severity?.level < 10
        ? 1
        : resLevel1[elementID]?.severity?.level >= 10 &&
            resLevel1[elementID]?.severity?.level < 20
          ? 2
          : 3;

    return getState(stateNumber);
  }, [resLevel1, getState]);

  if (!resLevel1) {
    return (
      <div className="card po-default">
        <div className="card-body" style={{ minHeight: '112px' }} />
      </div>
    );
  }

  return (
    <Container key={elementID} className="mb-1" $state={getStateNumber()}>
      <AppCard bodyClassName="p-0" headerClassName="p-0">
        <div className="default-content">
          <div className="content">
            <div className="content-col">
              <div className="text-primary header container-header">
                Nombre:
                {resLevel1[elementID]?.type && (
                  <div>
                    {`${resLevel1[elementID]?.type?.letter}`}
                    {`${resLevel1[elementID]?.type?.count ?? '0'}`}
                  </div>
                )}
              </div>
              {`${resLevel1[elementID]?.name || '-'} \n\n`}
              <div className="text-primary header">Causa (debido a):</div>
              <div>{`${resLevel1[elementID]?.cause || '-'} \n\n`}</div>
              <div className="text-primary header">EVENTO (se puede producir):</div>
              {`${resLevel1[elementID]?.event || '-'} \n\n`}
              <div className="text-primary header">EFECTO (por lo que):</div>
              {`${resLevel1[elementID]?.effect || '-'}`}
            </div>
            <div className="content-col">
              <div className="text-primary header">Propietarios:</div>
              {resLevel1[elementID]?.owners?.map((o) => (
                <div key={o?.id}>- {o?.name}</div>
              ))}
              <div className="text-primary header mt-2">Persona Responsable:</div>
              {resLevel1[elementID]?.additionalOwners}
            </div>
            <div className="content-col">
              <div className="third-col">
                <div className="column">
                  <div className="text-primary header">Objetivo estratégico</div>
                  <div>{resLevel1[elementID]?.strategicGoal?.name}</div>
                </div>
                <div className="column">
                  <div className="description">
                    <div className="text-primary header">Estado</div>
                    <div>
                      {resLevel1[elementID]?.state?.icon && (
                        <AppRemixIcon
                          icon={resLevel1[elementID]?.state?.icon}
                          size={15}
                        />
                      )}
                      <span className="ml-1">
                        {`${resLevel1[elementID]?.state?.name}`}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="content-col" style={{ padding: '6px' }}>
              <div className="fourth-col">
                <div className="first-col">
                  <div className="text-primary header">Acciones realizadas:</div>
                    {resLevel1[elementID]?.actionPlan}
                </div>
                <div className="second-col">
                  <div className="header">PROBABILIDAD:</div>
                  {resLevel1[elementID]?.probability?.level}
                  <div className="header">IMPACTO:</div>
                  {resLevel1[elementID]?.impact?.level}
                  <div className="header">SEVERIDAD</div>
                  {resLevel1[elementID]?.severity?.level}
                </div>
              </div>
            </div>
          </div>
          <div className="expand pointer" onClick={() => setIsOpened(!isOpened)}>
            <AppRemixIcon icon={getStateNumber()?.icon} color="white" />
          </div>
        </div>
      </AppCard>
      <UnmountClosed isOpened={isOpened}>
        <InecoRiskExpandedContainer elementID={elementID} />
      </UnmountClosed>
    </Container>
  );
}

const Container = styled.div`
  & > .card {
    border-radius: 5px;
    border: 1px solid ${(props) => props.$state?.bgColor};
  }

  .default-content {
    display: grid;
    grid-template-columns: 1fr 40px;

    .content {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;

      .content-col {
        border-right: 1px solid #ccc;
        padding: 8px;
        overflow-y: auto;
        height: 120px;
        font-size: 12px;

        .container-header {
          display: flex;
          flex: auto;
          justify-content: space-between;
        }

        hr {
          margin-top: 0.25rem;
          margin-bottom: 0.25rem;
        }

        .header {
          font-weight: bold;
          /* text-primary */
        }

        .agent-row {
          display: flex;
          flex-direction: row;
        }

        .container-other-agents {
          display: flex;
          justify-content: space-between;
        }

        .third-col {
          height: 100%;
          display: flex;
          justify-content: space-around;
          align-items: center;

          .column {
            display: flex;
            flex-direction: column;
            align-items: center;

            .header {
              font-weight: bold;
              /* text-primary */
            }

            .description {
              display: flex;
              justify-content: center;
              flex-direction: column;
              align-items: center;
            }
          }
        }

        .fourth-col {
          display: flex;
          justify-content: space-between;

          .header {
            font-weight: bold;
            /* text-primary */
          }

          .first-col {
            display: flex;
            flex-direction: column;
            align-items: center;
            align-self: center;
          }

          .second-col {
            text-align: end;
            align-self: center;
          }
        }
      }
    }
    & > .expand {
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      border-radius: 2px;
      font-size: 20px;
      height: 120px;
      margin: 2px;
      background-color: ${(props) => props.$state?.bgColor};
    }
  }
`;
